import { AUTOMATED_ACTION_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const automatedActionCriteriaSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.GET_AUTOMATED_ACTIONS_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default automatedActionCriteriaSchemaReducer;
